export class StorageConstants {
  public static readonly PlayerName: string = "playerName";
  public static readonly PlayerID: string = "playerID";
  public static readonly GameID: string = "gameID";
}
